import { _Api } from "../../api/_call";
import { error, success } from "./toastify";

/**
 * Download master import sample (Item / Size / Collection / Style / Category / Metal / Color).
 * @param {"item"|"size"|"collection"|"style"|"categoury"|"metal"|"color"|"stone"|"stone_group"|"stone_color"|"stone_shape"|"stone_cut"|"stone_clarity"|"stone_settingtype"|"stone_size"} type
 * @param {"xlsx"|"csv"} format
 * @param {(key: string) => string} [t]
 */
export const downloadItemMasterSampleTemplate = async (
  type = "item",
  format = "xlsx",
  t = (s) => s
) => {
  const exportFormat = String(format).toLowerCase() === "csv" ? "csv" : "xlsx";
  const masterType = String(type || "item").trim().toLowerCase();
  try {
    const res = await _Api(
      { type: masterType, format: exportFormat },
      "api/v1/App/Export/itemSampleTemplate"
    );
    if (res?.code === 200 && res?.filexlsx) {
      const a = document.createElement("a");
      a.hidden = true;
      a.href = res.filexlsx;
      a.download = `${masterType}_Import_Sample.${exportFormat}`;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      a.remove();
      success(res?.message || t("Sample template downloaded"));
      return true;
    }
    error(res?.message || res?.error || t("Could not download sample template"));
    return false;
  } catch (err) {
    console.log(err, "downloadItemMasterSampleTemplate");
    error(t("Could not download sample template"));
    return false;
  }
};
